import { useAppSelector } from "./store/hooks";
import { OptionData } from "./types/VisualizerTypes";
import { getInitialUrlArgs } from "./UrlArgsProvider";
import { useImageMedia } from "./utils/useImageMedia";

const assets:Record<string, {thumbnailPreview?: string, thumbnail?: string, thumbnailSummary?: string, proxyModel?: string}> = {};

declare global {
    interface Window { generatedAssets: typeof assets; }
}

window["generatedAssets"] = assets;

export function Preload()
{
    const groups = useAppSelector(s => s.configuration.currentVisualizerConfig.configuration.optionsGroups);
    const ready = useAppSelector(s => s.configuration.ready);

    if (!getInitialUrlArgs().generateAssets || !ready)
        return <></>

    const items = [];
    
    for (const groupId in groups)
    {
        for (const optionId in groups[groupId].options)
        {
            if (!groups[groupId].options[optionId].buildSessionOption)
                continue;

            items.push(<PreloadItem id={optionId} option={groups[groupId].options[optionId]} />)
        }
    }
    return items;
}

function PreloadItem(props: {id: string, option: OptionData })
{
    const thumbnailPreview = useImageMedia(props.option.thumbnailPreview);
    const thumbnail = useImageMedia(props.option.thumbnail);
    const thumbnailSummary = useImageMedia(props.option.thumbnailSummary);
    //const proxyModel = props.option.proxyModel;
    assets[props.id] = {
        thumbnailPreview: thumbnailPreview.url,
        thumbnail: thumbnail.url,
        thumbnailSummary: thumbnailSummary.url,
        //proxyModel: proxyModel?.url,   
    }
    return <></>
}